import {apiRequest, authBaseUrl} from './apiRequest';

import jwt_decode from "jwt-decode";
import qs from 'qs';

import {logger, logout} from '../utilities';

const LOG_PREFIX = '[auth.js]';

const MS_REFRESH_THRESHOLD = 250;

const isActiveToken = (token) => {
    return token && token.expires && (token.expires - new Date().getTime()) >= MS_REFRESH_THRESHOLD;
};

export const setAccess = (access) => {
    localStorage.setItem('@SLA/access', JSON.stringify(access));
};

export const getAccess = () => {

    try {
        const {access} = qs.parse(window.location.search, {ignoreQueryPrefix: true});

        if (access) {
            setAccess(JSON.parse(access));
        }
    } catch (error) {
    }

    return JSON.parse(localStorage.getItem('@SLA/access'));
};

export const hasValidToken = () => {
    if (hasValidAccess()) {
        return true;
    }

    if (hasValidRefresh()) {
        refresh();
        return true;
    }

    return false;
};

export const hasValidAccess = () => {
    return isActiveToken(getAccess());
};

export const deleteAccess = () => {
    localStorage.removeItem('@SLA/access');
};

export const setRefresh = (refresh) => {
    localStorage.setItem('@SLA/refresh', JSON.stringify(refresh));
};

export const getRefresh = () => {

    try {
        const {refresh} = qs.parse(window.location.search, {ignoreQueryPrefix: true});

        if (refresh) {
            setRefresh(JSON.parse(refresh));
        }
    } catch (error) {
    }


    return JSON.parse(localStorage.getItem('@SLA/refresh'));
};

export const hasValidRefresh = () => {
    return isActiveToken(getRefresh());
};

export const deleteRefresh = () => {
    localStorage.removeItem('@SLA/refresh');
};

export const getDataSource = () => {
    const tokenContents = jwt_decode(getAccess().token);
    return tokenContents.dataSource;
};

export const doAuthFlow = async (force = false) => {
    logger.debug(LOG_PREFIX, '.doAuthFlow()');

    try {
        if (!force && hasValidAccess()) {
            // we're good
            return;
        }

        if (hasValidRefresh()) {
            await refresh({token: getRefresh().token});
            return;
        }

    } catch (error) {
        logger.error(LOG_PREFIX, error);
    }
    logout();
};

const login = async (data) => {
    try {
        const response = await apiRequest(authBaseUrl, '/auth/login', {
            method: 'post',
            withAuth: false,
            data
        });
        const {access, refresh} = response;
        //need to restrict login to admin app by role. differing login endpoint?????
        // if(access.roles.includes('superuser') || access.roles.includes('admin')) {
        //   setAccess(access);
        //   setRefresh(refresh);
        // } else {
        //   throw new Error({"statusCode":401,"error":"Unauthorized","message":"Unable to log user in"})
        // }
        setAccess(access);
        setRefresh(refresh);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const refresh = async (data) => {
    try {
        const response = await apiRequest(authBaseUrl, '/auth/refresh', {
            method: 'post',
            withAuth: false,
            data,
        });
        const {access, refresh} = response;
        setAccess(access);
        setRefresh(refresh);

        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};


const reset = async (data) => {
    try {
        const response = await apiRequest(authBaseUrl, '/auth/reset', {
            method: 'post',
            withAuth: false,
            data,
        });

        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const update = async (data) => {
    try {
        const response = await apiRequest(authBaseUrl, '/auth/update', {
            method: 'post',
            withAuth: true,
            data,
        });
        const {access, refresh} = response;
        setAccess(access);
        setRefresh(refresh);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export default {
    login,
    refresh,
    reset,
    update
};
